import { useTranslation } from 'react-i18next';

import { generateClassName } from '@klv/shared/utils/functions';

import * as styles from './styles/csat.module.css';

import type { ICsat } from './types';
import ArticleVoteForm from '@klv/molecules/article-vote-form';

const Csat = ({
  articleId = '123456',
  ...props
}: ICsat) => {

  const { i18n } = useTranslation();
  const locale = i18n.language;

  return (
    <div className={generateClassName([styles.container])} {...props}>
      <div className={generateClassName([styles.csat, 'grid'])}>
        <ArticleVoteForm articleId={articleId} locale={locale} pageType='marketing' />
      </div>
    </div>
  );
};

export default Csat;
